import { gql } from "@apollo/client";

export interface LCFeedTime {
	milestoneId: number
	feedcurveId: number
	trigger: number
	state: number
	triggerValue: number
	day: number
	nday: number
	amount: number
}


export const LC_FEED_TIME = gql`
query GetLcFeedTime($domain: String!, $lanControllerId: Int!) {
	controller {
		lcFeedTime(domain: $domain, lanControllerId: $lanControllerId) {
			milestoneId
			feedcurveId
			trigger
			state
			triggerValue
			day
			nday
			amount
		}
	}
}
`

export interface LCFeedTimeResponse {
	controller: {
		lcFeedTime: LCFeedTime[] | null
	}
}

export interface LCFeedTimeArgs {
	domain: string;
	lanControllerId: number;
}

